import {
  RECEIVE_RETURN_OPTION_METHODS,
  RECEIVE_RETURN_OPTIONS,
  SELECT_RETURN_OPTION,
  SELECT_RETURN_OPTION_METHOD,
  RETURN_OPTION_VISIBILITY,
  RECEIVE_CONSOLIDATED_OPTIONS,
  RECEIVE_AND_SELECT_RETURN_OPTION_METHOD,
  ENABLE_AVAILABLE_OPTIONS_API_FLOW,
  RECEIVE_RETURN_PROHIBITED,
} from '../../actions/returnOptions';

import { NAVIGATION_TO_STEP_1 } from '../../actions/page';

export const initialState = {
  returnOptions: [],
  returnOptionMethods: {},
  selectedOptionId: '',
  selectedOptionMethodKey: '',
  returnOptionVisibility: [],
  isAvailableOptionsApi: false,
  isReturnProhibited: false,
};

export default (
  state = initialState,
  {
    type,
    data: {
      returnOptionMethod,
      returnOptionMethods,
      returnOptions,
      selectedOptionId,
      selectedOptionMethodKey,
      returnOptionVisibility,
    } = {},
  } = {},
) => {
  switch (type) {
    case RECEIVE_RETURN_OPTION_METHODS:
      return {
        ...initialState,
        returnOptionMethods,
      };

    case RETURN_OPTION_VISIBILITY:
      return {
        ...state,
        returnOptionVisibility,
      };

    case RECEIVE_RETURN_OPTIONS:
      return {
        ...state,
        returnOptions,
      };

    case RECEIVE_CONSOLIDATED_OPTIONS:
      return {
        ...state,
        returnOptions,
        returnOptionMethods,
        returnOptionVisibility: returnOptions,
      };

    case SELECT_RETURN_OPTION:
      return {
        ...state,
        selectedOptionId,
        selectedOptionMethodKey: '',
      };

    case SELECT_RETURN_OPTION_METHOD:
      return {
        ...state,
        selectedOptionMethodKey,
      };

    case RECEIVE_AND_SELECT_RETURN_OPTION_METHOD: {
      return {
        ...state,
        selectedOptionMethodKey,
        returnOptionMethods: {
          ...state.returnOptionMethods,
          [selectedOptionMethodKey]: returnOptionMethod,
        },
      };
    }

    case ENABLE_AVAILABLE_OPTIONS_API_FLOW:
      return {
        ...initialState,
        isAvailableOptionsApi: true,
      };

    case RECEIVE_RETURN_PROHIBITED:
      return {
        ...state,
        isReturnProhibited: true,
      };

    case NAVIGATION_TO_STEP_1:
      return {
        ...state,
        isReturnProhibited: false,
      }

    default:
      return state;
  }
};
